import * as React from "react"

import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const textareaVariants = cva(
  "flex min-h-[60px] w-full rounded-md border border-input bg-input px-3 py-2 text-sm placeholder:text-input-fg focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "",
        borderless: "border-0 focus-visible:ring-0 bg-transparent focus-visible:bg-input",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement>, VariantProps<typeof textareaVariants> {
    isValid?: boolean;
  }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, isValid = true, variant='default', ...props }, ref) => {
    return (
      <textarea
        className={cn(
          textareaVariants({ variant }),
          className,
          {
            'border-destructive': !isValid
          }
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
